export default __webpack_public_path__ + "static/media/display-1.084b21b2.jpg";